import React from "react";

const Users = () => {
  return (
    <div>
      <h1>hello users</h1>
    </div>
  );
};

export default Users;
